export function isUserProfileComplete(user) {
  if (!user) {
    console.log("Profile completion check: No user provided");
    return false;
  }
  
  const requiredFields = [
    "name",
    "phone",
    // "gender",
    "professions",
    "country_id",
    "interests",
    // Add any other required fields here
  ];
  
  console.log("Profile completion check for user:", user);
  console.log("Required fields:", requiredFields);
  
  const isComplete = requiredFields.every((field) => {
    if (field === "interests") {
      const value = user[field];
      const isValid = Array.isArray(value) ? value.length > 0 : value && value.toString().trim() !== "";
      console.log(`Field ${field}:`, value, "Valid:", isValid);
      return isValid;
    }
    const value = user[field];
    const isValid = value && value.toString().trim() !== "";
    console.log(`Field ${field}:`, value, "Valid:", isValid);
    return isValid;
  });
  
  console.log("Profile complete:", isComplete);
  return isComplete;
}
